<template>
  <v-container>
    <Carousel></Carousel>
    <v-row
      justify="center"
    >
      <v-col 
        cols="12"
        sm="12"
        :md="showFilters ? 4 : 12"
        :lg="showFilters ? 3 : 12"
        :xl="showFilters ? 2 : 12"
        :style="{display: showFilters ? '' : 'none'}"
      >
        <Collections 
          @SELECT_CATEGORY="filterByCategories"
          @SELECT_COLLECTION="filterByCollections"></Collections>
      </v-col>
      <v-col 
        cols="12"
        sm="12"
        :md="showFilters ? 8 : 12"
        :lg="showFilters ? 9 : 12"
        :xl="showFilters ? 10 : 12"
        class="pt-0"
      >
        <div>
          <div class="filter">
            <v-row
              justify="center"
              align="center"
            >
              <v-col
                cols="12"
                sm="6"
                md="5"
                lg="4"
                class="pt-0"
              >
                <v-btn
                  color="primary"
                  @click.stop="showFilters = !showFilters"
                  block
                >
                  <v-icon>{{ filterIcon }}</v-icon> {{ filterText }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="7"
                lg="8"
              >
                <v-text-field
                  v-model="search"
                  label="Rechercher..."
                  class="pt-0"
                  @keyup="searchFilter"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-row v-if="activeCategories.length == 0 && activeCollections.length == 0">
            <v-col cols="12"><v-icon>mdi-arrow-left</v-icon> Veuillez faire votre choix parmi nos sélections et nos supports</v-col>
          </v-row>
          <v-row v-else>
            <Card 
              :id="reference.id"
              :name="reference.name"
              :description="reference.description"
              :thumbnail="reference.thumbnail"
              :exRef="reference.exRef"
              :showFilters="showFilters"
              :isNew="reference.isNew"
              v-for="(reference, i) in filtRefs"
              :loading="searchLoading"
              :key="reference.id"
            ></Card>
            <img
              v-if="displayLazyTrigger"
              v-intersect="{
                handler: onIntersect,
                options: {
                  threshold: [0, 0.5, 1.0]
                }
              }"
            />
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // COMPONENTS
  import Carousel from '@/components/layout/Carousel'
  import Collections from './Collections'
  import Card from './Card'
  // EVENTS
  import { EventBus } from '@/main.js'
  import { AUTH_LOGOUT } from '@/store/actions/auth'
  import { LOADING, LOADED, CLOSE_MODAL } from '@/store/actions/general'
  import { SELECT_CATEGORY, SELECT_COLLECTION } from '@/store/actions/references'
  // REPOSITORIES
  import { RepositoryFactory } from '@/repositories/RepositoryFactory'
  const ReferencesRepository = RepositoryFactory.get('references')

  export default {
    name: 'List',

    components: { 
      Card,
      Carousel,
      Collections,
     },

    data() {
      return {
        references: [],
        errors: [],
        isLoading: false,
        search: '',
        colors: this.$vuetify.theme.themes.light,
        activeCollections: [],
        activeCategories: [],
        showFilters: false,
        isActive: false,
        lazyStep: 25,
        lastRefLoaded: 10,
        filtered: [],
        displayLazyTrigger: true,
        searchLoading: false,
      }
    },

    methods: {
      async getReferences() {
        this.isLoading = true
        let customerApiToken = this.$store.getters.getCustomer.apiToken
        await ReferencesRepository
          .getReferences(customerApiToken)
          .then(response => {
            this.isLoading = false
            this.references = Object.freeze(response.data)
            EventBus.$emit(LOADED)
            this.filter()
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 403) {
                this.$store
                  .dispatch(AUTH_LOGOUT)
                  .then(() => {
                    this.$router.push('/login').catch(err => {})
                  })
              }
            }
          })
      },
      onIntersect(entries, observer, isIntersecting) {
        this.displayLazyTrigger = false
        this.lastRefLoaded += this.lazyStep
      },
      filterByCollections(collections) {
        this.resetLastRefLoaded()
        this.activeCollections = collections
        this.filter()
      },
      filterByCategories(categories) {
        this.resetLastRefLoaded()
        this.activeCategories = categories
        this.filter()
      },
      resetLastRefLoaded() {
        this.lastRefLoaded = this.lazyStep
      },
      filter () {
        this.filtered = []
        this.references.forEach(ref => {
          if (!Object.prototype.hasOwnProperty.call(ref, 'collections') || ref.collections.length <= 0) return
          if (this.isRefMatched(ref)) {
            this.filtered.push(ref)
          }
        })
      },
      isRefMatched(ref) {
        let colFlag = ref.collections.some(element => {
          return this.activeCollections.includes(element)
        })
        if (this.activeCollections.length <= 0) {
          colFlag = true
        }
        let catFlag = ref.collections.some(element => {
          return this.activeCategories.includes(element)
        })
        if (this.activeCategories.length <= 0) {
          catFlag = true
        }
        const nameFlag = (ref.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
        let textFlag = nameFlag
        if (ref.description != null) {
          let descFlag = ref.description.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          textFlag = (descFlag || nameFlag)
        }

        return (textFlag && colFlag && catFlag)
      },
      searchFilter: _.debounce(function(event) {
        this.searchLoading = true
        if (!['up', 'right', 'down', 'left', 'enter'].includes(event.key.toLowerCase())) {
          this.filter()
        }
        this.searchLoading = false
      }, 300),
    },

    computed: {
      filtRefs() {
        this.displayLazyTrigger = true
        let filtered = []
        for (let i = 0; i <= this.lastRefLoaded; i++) {
          if (undefined !== this.filtered[i]) {
            filtered.push(this.filtered[i])
          }
        }

        return filtered
      },
      filterIcon() {
        if (this.showFilters) {
          return 'mdi-check'
        } else {
          return 'mdi-filter'
        }
      },
      filterText() {
        if (this.showFilters) {
          return 'Valider la sélection'
        } else {
          return 'Sélectionner les collections'
        }
      },
      width() {
        return window.innerWidth
      },
    },

    created() {
      EventBus.$emit(LOADING, 'Chargement des collections...')
      this.getReferences()
    }
  }
</script>

<style scoped>
  .headline,
  .v-card__subtitle {
    color: #000 !important;
  }
  .white-text {
    color: #fff;
  }
  .pl-35 {
    padding-left: 35px;
  }
  .slide-fade-enter-active {
    transition: all .2s ease;
  }
  .slide-fade-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(15px);
    opacity: 0;
  }
  .slide-fade-leave-to {
    transform: translateY(-15px);
    opacity: 0;
  }
</style>